import { render, staticRenderFns } from "./Show.vue?vue&type=template&id=47ae18dc&scoped=true"
import script from "./Show.vue?vue&type=script&lang=js"
export * from "./Show.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ae18dc",
  null
  
)

export default component.exports